'use client';

import React from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import Icon from '@repo/ui/icon';

import { toClassName } from 'helpers/format';

import { CtaSettings } from 'types/sanity.types';

import { styles } from '.';

type TProps = {
  locale: string;

  cta?: CtaSettings;
};

const CTASection = (props: TProps) => {
  const { cta } = props;

  const pathname = usePathname();

  if (pathname.includes('/contact')) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h3 className={styles.title}>{cta?.title}</h3>
        <p className={toClassName('text-sm sm:text-base -mt-2 mb-2')}>
          {cta?.description}
        </p>
        <Link
          href={cta?.button?.link?.url ?? ''}
          className={styles.link}
          target={cta?.button?.link?.isExternal ? '_blank' : ''}
        >
          {cta?.button?.label}
          <Icon accessor="arrow-right" className="text-sm" />
        </Link>
      </div>
    </div>
  );
};

export default CTASection;
